export default __webpack_public_path__ + "static/media/2503286.9167d588.jpg";